import React from 'react';

const PencilIcon = () => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ position: 'absolute', top: "80%", right: "1%" }}
        >
            <g clipPath="url(#clip0_965_5081)">
                <path
                    opacity="0.983"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.416 -0.0136719C11.5527 -0.0136719 11.6895 -0.0136719 11.8262 -0.0136719C12.1553 0.0460696 12.447 0.187345 12.7012 0.410156C13.0438 0.74363 13.3765 1.08543 13.6992 1.43555C13.835 1.62944 13.9307 1.83907 13.9863 2.06445C13.9863 2.26497 13.9863 2.4655 13.9863 2.66602C13.9194 2.9003 13.8146 3.11905 13.6719 3.32227C13.2796 3.71913 12.8831 4.11105 12.4824 4.49805C11.4796 3.48154 10.4769 2.47438 9.47461 1.47656C9.86653 1.08464 10.2585 0.692707 10.6504 0.300781C10.8827 0.133874 11.138 0.0290557 11.416 -0.0136719Z"
                    fill="black"
                />
                <path
                    opacity="0.99"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0.451172 13.9863C0.350911 13.9863 0.250651 13.9863 0.150391 13.9863C0.0865887 13.9407 0.0319012 13.8861 -0.0136719 13.8223C-0.0136719 13.722 -0.0136719 13.6218 -0.0136719 13.5215C0.281854 12.3759 0.578077 11.2275 0.875 10.0762C3.44988 7.50129 6.02473 4.92644 8.59961 2.35156C8.62696 2.33333 8.6543 2.33333 8.68164 2.35156C9.66145 3.33137 10.6413 4.31121 11.6211 5.29102C11.6393 5.31836 11.6393 5.3457 11.6211 5.37305C9.04622 7.94793 6.47137 10.5228 3.89649 13.0977C2.74518 13.3946 1.59673 13.6908 0.451172 13.9863Z"
                    fill="black"
                />
            </g>
            <defs>
                <clipPath id="clip0_965_5081">
                    <rect width="14" height="14" fill="black" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default PencilIcon;